import React from 'react'

const Footer = () => {
    return (
        <div>
            <footer className="main-footer">
                <div className="float-right d-none d-sm-inline-block">
                    <b>Version</b> 1.0.0 By Umid.S
                </div>
            </footer>
        </div>

    )
}

export default Footer;
